import React from 'react';

export default function Prev() {
  return (
    <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 17L1.41948 9.94281C0.860173 9.42211 0.860172 8.57789 1.41948 8.05719L9 1"
        stroke="#121212"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
